<template>
  <div v-if="isLoggedIn" class="inside">
    <flash-message
      transitionIn="animated swing"
      class="alert-system"
    ></flash-message>
    <nav
      class="navbar navbar-expand-lg fixed-top"
      style="background-color: #054375"
    >
      <div class="">
        <div
          class="d-flex align-items-center w-100"
          style="justify-content: space-between"
        >
          <a class="navbar-brand m-0" href="/">
            <img
              src="/img/logo.png"
              class="img-fluid"
              style="width: 120px"
              alt="Logo"
            />
          </a>

          <!-- Botão que abre/fecha -->
          <button
            class="navbar-toggler border-0 text-white d-flex align-items-center px-2"
            type="button"
            @click="toggleNavbar"
          >
            <span class="mr-1">{{ user.FullName ?? user.DocNumber }}</span>
            <i class="fa fa-user fa-fw"></i>
          </button>
        </div>

        <!-- Só aparece se 'isNavbarOpen' for true -->
        <!-- container do conteúdo expandido -->
        <div v-show="isNavbarOpen" class="mt-2" id="navbarContent">
          <div class="w-100">
            <!-- Linha CPF + Cadastro -->
            <div class="d-flex justify-content-between align-items-center">
              <div class="text-white">
                <p class="mb-0 small">
                  Seja bem-vindo(a):<br />{{ user.FullName }}
                </p>
                <p class="mb-0 small">
                  {{ user.DocNumber && user.DocNumber.replace(/[.\-/]/g, '').length > 11 ? 'CNPJ:' : 'CPF:' }}
                  {{ formatDocument(user.DocNumber) }}
                </p>
              </div>

              <ul class="navbar-nav">
                <li class="nav-item dropdown">
                  <a
                    class="nav-link dropdown-toggle p-0"
                    href="#"
                    id="userDropdown"
                    role="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    style="font-size: 14px; color: #0879c9"
                  >
                    Cadastro <i class="fa fa-user fa-fw"></i>
                  </a>
                  <div
                    class="dropdown-menu dropdown-menu-right"
                    aria-labelledby="userDropdown"
                  >
                    <router-link
                      to="/dashboard/cadastro"
                      class="dropdown-item"
                      style="color: #0879c9"
                    >
                      Meu Cadastro
                    </router-link>
                    <div
                      class="dropdown-item text-danger"
                      style="cursor: pointer"
                      @click="ActionDoLogout"
                    >
                      Sair
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </nav>

    <router-view></router-view>

    <div class="footer1" style="">
      <div class="container">
        <div class="row align-items-center pt-4">
          <div class="row col justify-content-around">
            <div>
              <h5><b>Tricard</b></h5>
              <ul class="list-unstyled">
                <li><a href="/" style="color: #1641cc">Home</a></li>
                <router-link
                  v-for="link in footerlinksc"
                  :key="link.text"
                  :to="{}"
                  @click.native="redirectPolitica(link, 'tricard')"
                  ><li>
                    <a target="_blank" style="color: #1641cc">{{
                      link.text
                    }}</a>
                  </li></router-link
                >
              </ul>
            </div>
            <div>
              <h5><b>Tribanco</b></h5>
              <ul class="list-unstyled">
                <li><a href="/" style="color: #1641cc">Home</a></li>
                <router-link
                  v-for="link in footerlinks"
                  :key="link.text"
                  :to="{}"
                  @click.native="redirectPolitica(link, 'tribanco')"
                  ><li>
                    <a target="_blank" style="color: #1641cc"
                      >{{ link.text }}
                    </a>
                  </li>
                </router-link>
              </ul>
            </div>
          </div>
          <div class="row col justify-content-center">
            <div>
              <p class="mb-0">Tricard | Fale conosco:</p>
              <a
                @click="saveLogcontatoPhone((ownerAlias = 'Tricard'))"
                class="btn btn-link"
                href="tel:+5508007223099"
                ><i class="fa fa-phone fa-fw mx-1 fa-lg"></i>0800 722 3099</a
              ><a
                @click="openWhats((ownerAlias = 'Tricard'))"
                class="btn btn-link"
                href="https://api.whatsapp.com/send?l=pt&amp;phone=551130033099"
                target="_blank"
                ><i class="fa fa-whatsapp fa-fw mx-1 fa-lg"></i>(11)
                3003-3099</a
              >
              <hr />
            </div>
            <div>
              <p class="mb-0">Tribanco | Fale conosco:</p>
              <a
                @click="saveLogcontatoPhone((ownerAlias = 'Tribanco'))"
                class="btn btn-link"
                href="tel:+5508009793355"
                ><i class="fa fa-phone fa-fw mx-1 fa-lg"></i>0800 979 3355</a
              ><a
                @click="openWhats((ownerAlias = 'Tribanco'))"
                class="btn btn-link"
                href="https://api.whatsapp.com/send?l=pt&amp;phone=553430033366"
                target="_blank"
                ><i class="fa fa-whatsapp fa-fw mx-1 fa-lg"></i>(34)
                3003-3366</a
              >
              <hr />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-center">
            <p class="mb-1">@tribanco | tricard</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import UserMenu from './components/UserMenu';
import { mapState } from "vuex";
import { mapActions } from "vuex";
import { formatDocument } from "@/utils/helpers";
import { sendAbandonmentBeacon } from "@/utils/abandonmentBeacon";

export default {
  name: "Dashboard",
  components: {
    //UserMenu
  },
  data: () => ({
    links: [{ icon: "", text: "Início", route: "/dashboard" }],
    hrefwhatsapp: "https://api.whatsapp.com/send?l=pt&phone=551132303765",
    footerlinks: [
      { icon: "", text: "Quem Somos", route: "somos" },
      {
        icon: "",
        text: "Termos de uso",
        route: "termos_tribanco",
        params: "Termos de uso",
      },
      {
        icon: "",
        text: "Política de privacidade",
        route:
          "https://www.tribanco.com.br/seg-corporativa/politica-de-privacidade/",
        params: "Política de privacidade",
      },
    ],
    footerlinksc: [
      { icon: "", text: "Quem Somos", route: "somos" },
      {
        icon: "",
        text: "Termos de uso",
        route: "termos_tricard",
        params: "Termos de uso",
      },
      {
        icon: "",
        text: "Política de privacidade",
        route:
          "https://www.tribanco.com.br/seg-corporativa/politica-de-privacidade/",
        params: "Política de privacidade",
      },
    ],
    largura: null,
    ipUser: null,
    isNavbarOpen: false,
  }),
  mounted() {
    this._inactivityMs = (parseInt(process.env.VUE_APP_ABANDONED_CART_INACTIVITY_MINUTES) || 10) * 60 * 1000;

    this._resetInactivityTimer = () => {
      clearTimeout(this._inactivityTimer);
      this._inactivityTimer = setTimeout(() => {
        const user    = this.user;
        const ownerId = this.$store.state.auth.ownerId;
        if (user?.DebtorID && ownerId) {
          sendAbandonmentBeacon(
            user.DebtorID,
            ownerId,
            user.PhoneNumber || null,
            'INACTIVITY',
          );
        }
        this.ActionDoLogout({ skipBeacon: true });
      }, this._inactivityMs);
    };

    this._onBeforeUnload = () => {
      const user    = this.user;
      const ownerId = this.$store.state.auth.ownerId;
      if (user?.DebtorID && ownerId) {
        sendAbandonmentBeacon(
          user.DebtorID,
          ownerId,
          user.PhoneNumber || null,
          'BROWSER_CLOSE',
        );
      }
    };

    const activityEvents = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'];
    activityEvents.forEach(e => window.addEventListener(e, this._resetInactivityTimer, { passive: true }));
    window.addEventListener('beforeunload', this._onBeforeUnload);

    this._resetInactivityTimer();
  },
  beforeDestroy() {
    clearTimeout(this._inactivityTimer);
    const activityEvents = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'];
    activityEvents.forEach(e => window.removeEventListener(e, this._resetInactivityTimer));
    window.removeEventListener('beforeunload', this._onBeforeUnload);
  },
  async created() {
    this.largura = window.screen.width;
    if (this.user != null) {
      await this.ActionGetUser();

      this.user.Menus.forEach((menuId) => {
        switch (parseInt(menuId)) {
          case 2:
            this.links.push({
              icon: "",
              text: "Contratos Negociáveis",
              route: "/dashboard/minhas-dividas",
            });
            break;
          case 1:
            this.links.push({
              icon: "",
              text: "Boletos Ativos",
              route: "/dashboard/meus-boletos",
            });
            break;
          case 3:
            this.links.push({
              icon: "",
              text: "Acordos",
              route: "/dashboard/meus-acordos",
            });
            break;
        }
      });
    }
  },
  methods: {
    formatDocument,
    ...mapActions("auth", [
      "ActionDoLogout",
      "ActionMenuLinks",
      "ActionGetUser",
      "ActionGetWhatsText",
      "ActionLogContato",
    ]),

    async saveLogcontatoPhone(ownerAlias) {
      this.ipUser = localStorage.getItem("ipUser");
      this.ActionLogContato({
        DocNumber: this.user.DocNumber ? this.user.DocNumber : null,
        DebtorID: this.user.DebtorID ? this.user.DebtorID : null,
        tag: localStorage.getItem("tag"),
        ownerAlias: ownerAlias,
        contactType: "Telefone",
        IP: this.ipUser ? this.ipUser : "",
        OS: navigator.platform,
      });
    },
    async openWhats(ownerAlias) {
      this.ipUser = localStorage.getItem("ipUser");
      var whats = await this.ActionGetWhatsText({
        OS: navigator.platform,
        IP: this.ipUser ? this.ipUser : "",
      });
      this.hrefwhatsapp = this.hrefwhatsapp + "&text=" + whats[0];
      window.open(this.hrefwhatsapp, "_blank");

      this.ActionLogContato({
        DocNumber: this.user.DocNumber ? this.user.DocNumber : null,
        DebtorID: this.user.DebtorID ? this.user.DebtorID : null,
        tag: localStorage.getItem("tag"),
        ownerAlias: ownerAlias,
        contactType: "WhatsApp",
        IP: this.ipUser ? this.ipUser : "",
        OS: navigator.platform,
      });
    },

    redirectPolitica(link, banco) {
      if (link.route.includes("https://")) {
        window.open(link.route, "_blank").focus();
      } else {
        this.$router.push({
          name: link.route,
          query: { title: link.text, banco },
        });
      }
    },

    toggleNavbar() {
      this.isNavbarOpen = !this.isNavbarOpen;
      this.adjustBodyPadding();
    },

    adjustBodyPadding() {
      if (this.largura > 500) {
        document.body.style.paddingTop = this.isNavbarOpen ? "60px" : "";
      } 
      else if (this.largura < 500) {
        document.body.style.paddingTop = this.isNavbarOpen ? "60px" : "";
      }
    },
  },
  computed: {
    ...mapState("auth", ["user"]),
    isLoggedIn() {
      return this.$store.getters["auth/isLoggedIn"];
    },
  },
};
</script>
<style>
#blue,
a {
  color: #1641cc;
}
</style>
